  export default function getBgColor(origin) {
    return origin ? `body-${origin}` : "body-asian-womxn";
  }
